import React from "react";
import { Box, Divider } from "@edreamsodigeo/prisma-design-system";
import BookingAuthentication from "../../../components/BookingAuthentication";
const BookingAuthenticationWrapper = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
  py: "2x_big"
}, /*#__PURE__*/React.createElement(Divider, {
  orientation: "vertical",
  color: "neutral.40"
})), /*#__PURE__*/React.createElement(Box, {
  px: "2x_big",
  flex: "1",
  py: "2x_big"
}, /*#__PURE__*/React.createElement(BookingAuthentication, null)));
export default BookingAuthenticationWrapper;